
import React from "react";


export const GeneratePPTIcon = ({ color }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.5833 12.5H18.3333V3.75C18.3333 1.6825 16.6508 0 14.5833 0H5.41667C3.34917 0 1.66667 1.6825 1.66667 3.75V12.5H0.416667C0.186667 12.5 0 12.6867 0 12.9167C0 13.1467 0.186667 13.3333 0.416667 13.3333H9.58333V17.5H7.08333C5.93417 17.5 5 18.4342 5 19.5833C5 19.8133 5.18667 20 5.41667 20C5.64667 20 5.83333 19.8133 5.83333 19.5833C5.83333 18.8942 6.39417 18.3333 7.08333 18.3333H12.9167C13.6058 18.3333 14.1667 18.8942 14.1667 19.5833C14.1667 19.8133 14.3533 20 14.5833 20C14.8133 20 15 19.8133 15 19.5833C15 18.4342 14.0658 17.5 12.9167 17.5H10.4167V13.3333H19.5833C19.8133 13.3333 20 13.1467 20 12.9167C20 12.6867 19.8133 12.5 19.5833 12.5ZM2.5 3.75C2.5 2.14167 3.80833 0.833333 5.41667 0.833333H14.5833C16.1917 0.833333 17.5 2.14167 17.5 3.75V12.5H2.5V3.75Z" fill={color}/>
    </svg>
  );
};



